import { useQuery } from 'react-query';

import Api from '../../api/api';
import { PaginatedList } from '../../../types/PaginatedList';
import { Post } from '../../../types/Post';

export type ReportedPostsDto = {
  page?: number;
  limit?: number;
  sort?: string;
  search?: string;
};

export type ReportedPost = Post & {
  deactivated: string | Date | null;
  lastReportedDate: string | Date;
  reportCount: number;
};

const reportedPosts = async (params: ReportedPostsDto): Promise<PaginatedList<ReportedPost>> => {
  const [response, bodyOrError] = await Api.get(`posts/reported`, params);

  if (!response?.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

const useGetAllReportedPosts = (params: ReportedPostsDto) => {
  return useQuery({
    queryKey: ['reportedPosts', params],
    queryFn: () => reportedPosts(params),
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
};

export default useGetAllReportedPosts;
